module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/ula-parfienowicz-ca2c9a4496e853bbc2a207061ce50445.png";